import { ArrowRight, MessageSquareText } from "lucide-react";
import { EMAIL, IMAGES, MAILTO, PHONE_DISPLAY, PHONE_TEL, smsLink } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { useSectionNav } from "@/hooks/useSectionNav";

const FinalCta = () => {
  const go = useSectionNav();
  return (
    <section className="relative overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0" aria-hidden="true">
        <img src={IMAGES.wheels} alt="" loading="lazy" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-obsidian/85" />
      </div>
      <div className="relative z-10 mx-auto max-w-7xl px-5 py-24 text-center sm:px-8 sm:py-36">
        <Reveal>
          <p className="eyebrow justify-center">Mobile Detailing — Gap, PA</p>
          <h2 className="mx-auto mt-4 max-w-3xl font-display text-5xl font-bold uppercase leading-[0.92] tracking-tight text-white sm:text-6xl lg:text-7xl">
            Ready for a Cleaner Vehicle?
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
            Send us your vehicle information today and get your mobile detailing quote.
          </p>
          <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
            <button onClick={() => go("quote")} className="btn-primary" data-testid="final-cta-quote-button">
              Get a Quote
              <ArrowRight size={17} strokeWidth={2.4} />
            </button>
            <a href={smsLink()} className="btn-outline" data-testid="final-cta-text-button">
              <MessageSquareText size={17} strokeWidth={2.2} />
              Text Us
            </a>
          </div>
          <div className="mt-10 flex flex-col items-center justify-center gap-2 font-mono text-sm tracking-wider text-slate-300 sm:flex-row sm:gap-8">
            <a href={PHONE_TEL} className="transition-colors hover:text-blue-400" data-testid="final-cta-phone">{PHONE_DISPLAY}</a>
            <span className="hidden text-slate-600 sm:inline" aria-hidden="true">/</span>
            <a href={MAILTO} className="transition-colors hover:text-blue-400" data-testid="final-cta-email">{EMAIL}</a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCta;
